import requestManager from '@/components/platformApi/requestManager'

import appHelper from "@/util/appHelper";

export default {

    /**
     * @param   {String|Array}  id
     * @param   {Function}      callback
     */
    subscribe(id, callback) {

        if (typeof(id) === 'object')
        {
            id = id.join(',');
        }

        return requestManager.request({
            url: 'portal/live/subscribe',
            method : 'post',
            params: {
                liveItemIdList: id
            }
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }
            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }
            callback(result);
        });
    }

};
